import { addReaction } from '../reactions'
import { normalizeShortlistCandidate } from './storage'
import { shortlistActionContext } from './tracking'
import { SHORTLIST_CHANGE_EVENT } from './sync'

let pending = false
const acknowledgedCaseIds = new Set()
// 一覧のローカル保存が競合しないよう、別事例の操作も直列化する。
export const isShortlistPending = () => pending

export async function persistShortlistSave(store, candidate, surface) {
  const normalized = normalizeShortlistCandidate(candidate)
  if (normalized === null) return { ok: false, reason: 'invalid-candidate' }
  const { caseId } = normalized
  if (isShortlistPending()) return { ok: false, reason: 'pending' }
  const state = store.read()
  if (!state.ok) return state
  if (state.cases.some((entry) => entry.caseId === caseId)) return { ok: true, saved: true, count: state.count }
  pending = true
  window.dispatchEvent(new Event(SHORTLIST_CHANGE_EVENT))
  try {
    // 通信成功後にブラウザ保存が失敗した場合、再試行は保存だけ行う。
    if (!acknowledgedCaseIds.has(caseId)) {
      await addReaction('reform_case_shortlist_saved', shortlistActionContext({ caseId, surface, count: state.count + 1 }))
      acknowledgedCaseIds.add(caseId)
    }
    const result = store.save(normalized)
    if (result.ok) acknowledgedCaseIds.delete(caseId)
    return result
  } catch (_error) {
    return { ok: false, reason: 'request-failed' }
  } finally {
    pending = false
    window.dispatchEvent(new Event(SHORTLIST_CHANGE_EVENT))
  }
}
